import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const Faq = lazy(() => import('components/Sections/Faq'))
const Footer = lazy(() => import('components/Layout/Footer'))

function FaqPage() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <Faq />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default FaqPage